// dicompare-web version (keep in sync with package.json and git tags)
// Updated automatically by the version-bump GitHub Action on release
export const VERSION = '0.6.0';

// dicompare pip package version
export const DICOMPARE_VERSION = '0.3.0';
